// A tab body before its data: a spinner, or why it could not load with Retry. Fills the space the
// table will take, so the strip and filters above never move (DD-042).
import { SpinnerIcon } from "@/components/icons";
import { RetryBlock } from "./RetryBlock";

export interface TabPendingProps {
  failed: boolean;
  message: string;
  retrying: boolean;
  onRetry: () => void;
}

export function TabPending({ failed, message, retrying, onRetry }: TabPendingProps) {
  return failed ? (
    <div className="flex-1 flex items-center justify-center px-4">
      <RetryBlock message={message} retrying={retrying} onRetry={onRetry} />
    </div>
  ) : (
    <div className="flex-1 flex items-center justify-center">
      <SpinnerIcon className="w-6 h-6 text-gray-400" />
    </div>
  );
}
